import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-gray-400 py-6 mt-6 border-t border-gray-700">
      <p className="text-sm">
        © {currentYear} Programa de Afiliados. Todos los derechos reservados.
      </p>
      <div className="flex justify-center space-x-4 mt-2">
        <a href="#" className="text-xs hover:text-white transition-colors">
          Términos de Servicio
        </a>
        <a href="#" className="text-xs hover:text-white transition-colors">
          Política de Privacidad
        </a>
        <a href="#" className="text-xs hover:text-white transition-colors">
          Soporte
        </a>
      </div>
    </footer>
  );
};

export default Footer;
